const links = {
  instagram: "https://www.instagram.com/theeutecticband/",
  facebook: "https://www.facebook.com/TheEutecticBand",
  youtube: "https://www.youtube.com/channel/UCd5L8yJtmeErGBCqEbP8Whg",
  featuredVideo: "https://www.youtube.com/embed/zoZT5HZHoF0"
}

export default links